var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.currentCase
    ? _c("v-list-group", {
        scopedSlots: _vm._u(
          [
            {
              key: "activator",
              fn: function () {
                return [
                  _c("v-list-item-title", [_vm._v(" Messages ")]),
                  _c(
                    "v-list-item-action",
                    [
                      _c(
                        "MenuMore",
                        { attrs: { "offset-x": "", "offset-y": "" } },
                        [
                          _c(
                            "v-list",
                            { attrs: { dense: "" } },
                            [
                              _c(
                                "v-list-item",
                                { on: { click: _vm.downloadMessages } },
                                [
                                  _c(
                                    "v-list-item-icon",
                                    [_c("v-icon", [_vm._v("get_app")])],
                                    1
                                  ),
                                  _c("v-list-item-content", [
                                    _vm._v(" Download Messages "),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "v-list-item",
                                { on: { click: _vm.clearMessages } },
                                [
                                  _c(
                                    "v-list-item-icon",
                                    [_c("v-icon", [_vm._v("clear_all")])],
                                    1
                                  ),
                                  _c("v-list-item-content", [
                                    _vm._v(" Clear Messages "),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "default",
              fn: function () {
                return [
                  _c(
                    "v-scroll-x-transition",
                    { attrs: { group: "" } },
                    _vm._l(_vm.messages, function (message) {
                      return _c(
                        "v-list-item",
                        { key: message.id, attrs: { dense: "" } },
                        [
                          _c(
                            "v-list-item-content",
                            { staticClass: "pt-0 pb-1 pl-2" },
                            [
                              _c(
                                "v-tooltip",
                                {
                                  attrs: { "open-delay": "1000", top: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function (ref) {
                                          var on = ref.on
                                          var attrs = ref.attrs
                                          return [
                                            _c(
                                              "v-list-item-title",
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    staticClass: "text-caption",
                                                  },
                                                  "v-list-item-title",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(message.message) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [_c("span", [_vm._v(_vm._s(message.message))])]
                              ),
                              _c(
                                "v-list-item-subtitle",
                                { staticClass: "text-caption" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      new Date(message.created).toLocaleString()
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          false,
          3234715715
        ),
        model: {
          value: _vm.expanded,
          callback: function ($$v) {
            _vm.expanded = $$v
          },
          expression: "expanded",
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }